// mantine
import { Collapse } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// components
import { IActor } from '@newo/api/gateway';
import NoRecords from '@/components/NoRecords';
import SectionHeading from '@/components/SectionHeading';
import ActorData from '@/modules/Personas/components/ActorData';
// utils

interface ActorsProps {
    actors: IActor[];
    isSuccess: boolean;
}

const Actors = ({ actors, isSuccess }: ActorsProps) => {
    const [isOpened, { toggle }] = useDisclosure(true);
    return (
        <div className="break-all">
            <SectionHeading
                isOpened={isOpened}
                title="Actors"
                onClick={toggle}
            />
            <Collapse in={isOpened}>
                <div className="flex flex-col gap-4 p-5 pt-0">
                    {isSuccess && actors.length === 0 ? (
                        <NoRecords> No Actors found</NoRecords>
                    ) : undefined}
                    {actors.map((actor) => (
                        <ActorData data={actor} key={actor.id} />
                    ))}
                </div>
            </Collapse>
        </div>
    );
};

export default Actors;
